import component from './upsell.component'
import './upsell.scss'

let module = angular.module('upsell', [])
	.component('upsell', component)
	.name;

export default module;


// WEBPACK FOOTER //
// ./app/components/upsell/upsell.js